import { InstallSections } from "@/components/install/InstallSections";

export function InstallPage() {
  return <InstallSections />;
}
